/**
 * @module app.shared
 */

import { autoinject } from 'aurelia-framework';
import { Api } from 'app/shared/lib/api/api';
import { IApiAuthenticationResults } from 'app/shared/lib/api/api-types';
import { AppLogger } from 'app/shared/lib/logging/app-logger';
import { IForgotLoginRequest, IResetPasswordRequest } from 'app/shared/models/assistance-models';

@autoinject
export class AssistanceService {

    constructor(public readonly api: Api, private readonly logger: AppLogger) {
        this.logger.source = this;
    }

    ////****************** Queries **************************************************////

    public async resetPassword(request: IResetPasswordRequest): Promise<IApiAuthenticationResults> {
        const action = this.api
            .action(null, 'authentication/password/reset', request)
            .withTenant('system');
        return await this.api.post(action, { authenticate: false });
    }

    public async changePassword(loginName: string, password: string, newPassword: string): Promise<IApiAuthenticationResults> {
        const action = this.api
            .action(null, 'authentication/password/change', { credentials: { loginName, password }, newPassword })
            .withTenant('system');
        return await this.api.post(action, { authenticate: true });
    }

    public async changePasswordByCode(code: string, newPassword: string): Promise<IApiAuthenticationResults> {
        const action = this.api
            .action(null, 'authentication/password/reset/change', { code, newPassword })
            .withTenant('system');
        return await this.api.post(action, { authenticate: false });
    }

    public async forgotLoginName(request: IForgotLoginRequest): Promise<IApiAuthenticationResults> {
        const action = this.api
            .action(null, 'authentication/login/forgot', request)
            .withTenant('system');
        return await this.api.post(action, { authenticate: false });
    }

    public async retrieveLoginNames(code: string): Promise<IApiAuthenticationResults> {
        const action = this.api
            .action(null, 'authentication/login/retrieve', { code })
            .withTenant('system');
        return await this.api.post(action, { authenticate: false });
    }

}
